import React, {FC, useCallback, useMemo, useState} from 'react';

import {TagJobModel} from '../../../../models/api/jobModel';
import {CustomViewBackfillBanner} from './customViewBackfillBanner';

/*
 * Props.
 */

interface CustomViewBackfillBannersProps {
  jobs: ReadonlyArray<TagJobModel>;
}

/*
 * Component.
 */

export const CustomViewBackfillBanners: FC<CustomViewBackfillBannersProps> = ({jobs}) => {
  const [dismissedJobIds, setDismissedJobIds] = useState<ReadonlyArray<number>>([]);

  /*
   * Event handlers.
   */

  const onBannerRequestClose = useCallback(
    (jobId: number) => {
      setDismissedJobIds((jobIds) => [...jobIds, jobId]);
    },
    [setDismissedJobIds],
  );

  /*
   * Render.
   */

  const visibleJobs = useMemo(
    () => jobs.filter((j) => !dismissedJobIds.includes(j.id)),
    [jobs, dismissedJobIds],
  );

  const visibleJobRenders = visibleJobs.map((job) => (
    <CustomViewBackfillBanner key={job.id} job={job} onDismissClick={() => onBannerRequestClose(job.id)} />
  ));

  return <>{visibleJobRenders}</>;
};
